"use strict";

define('components/form',[
  "components/fileuploader",
  "inputmask.numeric.extensions",
  "typeahead",
  "modernizr",
  "datepicker",
  "select2",
], function (fileuploader, InputMask, Bloodhound) {
  var formComponent = {
    changedFieldNames: {},

    init: function (formNode) {
      if (formNode.data("is-initialized-by-form-component")) return;
      formNode.data("is-initialized-by-form-component", true);

      formComponent.initRemainingCountIndicators(formNode);
      formComponent.initInputMasks(formNode);
      formComponent.initObjectRefInputs(formNode);
      formComponent.initControlledVocabInputs(formNode);
      formComponent.initDocumentUploader(formNode);
      formComponent.initSelect2(formNode);
      formComponent.initSelect2ObjectRefInputs(formNode);
      formComponent.initDocumentSharingAdd(formNode);
      formComponent.initDatePicker(formNode);
      formComponent.initListSortDnD(formNode);
      formComponent.initExclusiveCheckbox(formNode);
      formComponent.initAddressField(formNode);
      fileuploader.init(formComponent, formNode);

      formNode.find(".initial-focus").focus();

      // Hide the close button from elements which shouldn't be removed.
      formNode.find(".deform-seq-container").each(function () {
        $(this)
          .find(".deform-close-button")
          .each(function (index) {
            var $item_node = $(this).closest(".deform-seq-item");
            var $oid_node = $item_node.closest(".deform-seq");
            var $before_node = $oid_node.find(".deform-insert-before").last();
            var min_len = parseInt($before_node.attr("min_len") || "0", 10);
            if (index < min_len) $(this).addClass("hidden");
          });
      });

      // Click handler for sequence deletes
      formNode.find(".deform-seq-container").click(function (e) {
        if (!$(e.target).hasClass("deform-close-button")) {
          return;
        }

        // If removing a 'primary' item from the sequence, then mark the first item in the sequence as primary.
        var seqItem = $(e.target).closest(".deform-seq-item");
        var primaryRadioChecked = seqItem.find("input:radio:checked");
        formComponent.removeSequenceItem(e.target);
        if (primaryRadioChecked.length > 0) {
          var primaryRadio = $(this).find("input[type=radio][name=is_primary]");
          if (primaryRadio.length > 0) {
            $(primaryRadio[0]).prop("checked", true);
          }
        }
      });

      formNode.find(".photo-selector-container > img").click(function (e) {
        var checkbox = $(this).prev();
        checkbox.prop("checked", !checkbox.prop("checked"));
        e.preventDefault();
      });

      // Block enter key submit for all forms in editable_modules and modals
      if (
        formNode.closest(".modal").length > 0 ||
        formNode.closest(".module").length > 0
      ) {
        formNode.keydown(function (event) {
          if (
            event.keyCode == 13 &&
            "button" != event.target.tagName.toLowerCase() &&
            ("textarea" != event.target.tagName.toLowerCase() ||
              $(event.target).is(".object_ref_edit"))
          ) {
            event.preventDefault();
            return false;
          }
        });
      }

      var textareaMaxHeight = 500; // in pixels

      var computeHeight = function (elem) {
        var paddingHeight = $(elem).innerHeight() - $(elem).height();
        var desiredHeight = elem.scrollHeight - paddingHeight;

        return Math.min(
          textareaMaxHeight,
          Math.max($(elem).height(), desiredHeight)
        );
      };

      formNode
        .find("textarea.auto-grow")
        .each(function () {
          // Set the initial height of auto-grow textareas
          $(this).height(computeHeight(this));
        })
        .keyup(function (e) {
          var newHeight = computeHeight(this);
          if (newHeight > $(this).height()) {
            $(this).height(newHeight);
          }
        });

      if (/^POST$/i.test(formNode.attr("method"))) {
        formComponent._initSaveWarning(formNode);
      }
    },

    initDatePicker: function (formNode) {
      if (Modernizr.touch && Modernizr.inputtypes.date) {
        formNode.find("input.datepicker-field").attr("type", "date");
      } else {
        var options = {
          format: "m/d/yyyy",
          autoclose: true,
          todayBtn: "linked",
          todayHighlight: true,
          assumeNearbyYear: true,
        };

        // Some pages have a floating static header element
        // If datepicker is too close to top of page, will be obscured
        // Not recalculated on window resize: adding a bit of buffer
        const datepicker_near_top = formNode.offset().top <= 500
        if (formNode.is("td") || formNode.is("#transaction_batch_add") || datepicker_near_top) {
          options.orientation = "right bottom";
        }

        // Use a date picker for non-touch devices, regardless of support for the date type.
        formNode.find("input.datepicker-field").each(function () {
          var value = $(this).val();

          if (value) {
            $(this).val(
              value.replace(/^\s*(\d\d(\d\d)?)-(\d\d?)-(\d\d?)\s*/, "$3/$4/$1")
            );
          }
          if (!$(this).attr("readonly")) {
            $(this).datepicker(options);
          }
        });
      }
    },

    getSerializedDateFieldValue: function (dateInputNode) {
      return dateInputNode
        .val()
        .replace(/^\s*(\d\d?)\/(\d\d?)\/(\d\d(?:\d\d)?)\s*/, "$3-$1-$2");
    },

    rewriteDateFieldForSerialization: function (dateInputNode) {
      var value = formComponent.getSerializedDateFieldValue(dateInputNode);
      dateInputNode.val(value);
    },

    rewriteDateFieldForDisplay: function (dateInputNode) {
      var value = dateInputNode
        .val()
        .replace(/^\s*(\d\d(?:\d\d)?)-(\d\d?)-(\d\d?)\s*/, "$2/$3/$1");
      dateInputNode.val(value);
    },

    serialize: function (formNode) {
      // First, convert all .datepicker-field fields that aren't using the
      // native type=date into ISO 8601 format
      formNode.find("input[type=text].datepicker-field").each(function () {
        formComponent.rewriteDateFieldForSerialization($(this));
      });


      if (typeof tinymce !== "undefined") {
        formNode.find("textarea").each(function () {
          const tinymceInstance = tinymce.get($(this).get(0).id);
          if (tinymceInstance) {
            tinymceInstance.save();
          }
        });
      }

      var formData = new FormData(formNode[0]);
      formNode.find(".file_select").each(function () {
        var file_select = $(this);
        var fileList = file_select.data("dragdrop_files");
        if (fileList && fileList.length > 0) {
          for (var i = 0, n = fileList.length; i < n; i++) {
            formData.append(file_select.attr("name"), fileList[i]);
          }
        }
      });

      // Convert the date fields back to presentation format
      formNode.find("input[type=text].datepicker-field").each(function () {
        formComponent.rewriteDateFieldForDisplay($(this));
      });

      return formData;
    },

    initRemainingCountIndicators: function (formNode) {
      function updateThisStatusIndicator() {
        var max = parseInt($(this).attr("maxlength"), 10);
        var remainingCount = Math.max(0, max - $(this).val().length);
        var remaining =
          remainingCount < max
            ? remainingCount +
              (remainingCount == 1 ? " character left" : " characters left")
            : max + " characters max";
        $(this)
          .closest(".form-group")
          .find(".status-indicator")
          .text(remaining);
      }

      formNode
        .find('input[maxlength][data-show-remaining-count="yes"]')
        .each(function () {
          updateThisStatusIndicator.call(this);
          $(this).on("input", updateThisStatusIndicator);
        });
    },

    initInputMasks: function (formNode) {
      var decimalMask = InputMask({
        alias: "decimal",
        groupSeparator: ",",
        autoGroup: true,
        digits: 2,
        digitsOptional: false,
      });
      formNode.find('[data-input-type="decimal"]').each(function () {
        decimalMask.mask(this);
      });

      var integerMask = InputMask({
        alias: "integer",
        groupSeparator: ",",
        autoGroup: true,
        digits: 0,
        digitsOptional: true,
      });
      formNode.find('[data-input-type="integer"]').each(function () {
        integerMask.mask(this);
      });
    },

    initObjectRefInputs: function (formNode) {
      // Initialize all object_ref components in the form.  Uses textarea instead of input to work around
      // the chrome autofill aggressiveness.
      formNode.find(".object_ref_edit").each(function () {
        var objectRefInput = $(this);
        var fieldId = objectRefInput.attr("id");
        var objectTypeId = objectRefInput.data("object-type") || "";
        var objectFilter = objectRefInput.data("object-filter") || "";
        var createNew = objectRefInput.data("create-new") || "";
        var allowCreateNewOnExactMatch =
          objectRefInput.data("allow-exact-match-create-new") || "";
        var refFormName = objectRefInput.data("form-name") || "";
        var refFormContext = objectRefInput.data("form-context") || "";

        // Prevent new-lines in the textarea
        objectRefInput.keydown(function (e) {
          if (e.keyCode == 13) {
            e.preventDefault();
            return false;
          }
        });

        var typeaheadOptions = {
          minLength: 1,
          highlight: true,
          hint: false,
        };

        var autoselect = objectRefInput.data("autoselect");

        if (autoselect != "") {
          typeaheadOptions.autoselect = autoselect;
        }

        var typeaheadQueryOptions = {};
        if (objectTypeId != "") {
          typeaheadQueryOptions.t = objectTypeId;
        }
        if (objectFilter != "") {
          typeaheadQueryOptions.f = objectFilter;
        }
        if (refFormName != "") {
          typeaheadQueryOptions.form_name = refFormName;
        }
        if (refFormContext != "") {
          typeaheadQueryOptions.form_context = refFormContext;
        }        

        // The handler for selects of typehead results.  Also reused for faux results (results that contain
        // the same data structure returned by typeahead search but originate from another source.)
        var typeaheadSelectHandler = function (
          fieldId,
          datum,
          appendEmptyField
        ) {
          if (datum.id === null) {
            /* create a new item */
            $("#" + fieldId + "-lazy_create").val("true");
            objectRefInput.trigger("jsq:createNewSelected", [
              fieldId,
              datum.label,
              datum.object_type,
            ]);
          } else {
            /* select an existing item */
            var objectType = datum.id[0];
            var objectId = datum.id.substring(1);

            // Avoid selecting an existing item if the types dont match
            var requestedObjectType = objectRefInput.data("object-type");
            if (objectRefInput.data("object-filter") == "is_staff_or_person") {
              requestedObjectType = null;
            }
            if (
              typeof requestedObjectType != "undefined" &&
              requestedObjectType &&
              requestedObjectType != objectType
            ) {
              return;
            }

            $("#" + fieldId + "-type").val(objectType);
            $("#" + fieldId + "-id").val(objectId);

            objectRefInput.trigger("jsq:objectSelected", [
              fieldId,
              datum.label,
              objectType,
              objectId,
              datum.sub_type,
            ]);
          }
          $("#" + fieldId + "-name").val(datum.label);

          // Hide the editable-input and show the (read-only) display input
          var objectRefDisp = $("#" + fieldId + "-disp");
          objectRefDisp.find("input").val(datum.label);
          objectRefDisp.removeClass("hidden");

          var objectRefEdit = $("#" + fieldId + "-edit");
          objectRefEdit.addClass("hidden");

          // Remove any error messages
          var formGroup = objectRefInput.closest(".form-group");
          formGroup.removeClass("has-error");
          formGroup.find(".error-msg").remove();

          // If this was a sequence item containing a single objectref, then trigger the 'add item'
          // to create a new blank input field
          var seqContainer = objectRefInput.closest(".deform-seq-container");
          var seqItems = seqContainer.find(".deform-seq-item");
          if (seqItems.length == 1) {
            var addLink = seqContainer
              .siblings(".form-seq-add-container")
              .find("a.deform-seq-add");
            if (addLink.length == 1 && appendEmptyField !== false) {
              addLink.click();
            }
          }
        };

        // Create faux typeahead result click handler.  Inserts a new field containing
        // faux-result data.
        $(this)
          .closest(".object_ref_field")
          .on("click", ".faux-typeahead-result", function (e) {
            e.preventDefault();
            var eventTarget = $(e.target);
            var fieldId = eventTarget.data("field-id");
            var datum = {
              id: eventTarget.attr("data-datum-id"),
              label: eventTarget.data("datum-label"),
              object_type: eventTarget.data("datum-object_type"),
              sub_type: eventTarget.data("datum-sub_type"),
              url: eventTarget.data("datum-url"),
            };

            var field = eventTarget.closest(".deform-seq-item");

            // Clone the field to create a new result. Remove the faux-results that
            // were added to the original version from the clone.
            var newField = field.clone();
            newField
              .find(".object_ref_field")
              .addClass("faux_object_ref_field");
            newField.find(".faux-results").remove();

            var newFieldId =
              fieldId + "-new-" + eventTarget.attr("data-datum-id");
            newField
              .find("#" + fieldId + "-type")
              .attr("id", newFieldId + "-type");
            newField.find("#" + fieldId + "-id").attr("id", newFieldId + "-id");
            newField
              .find("#" + fieldId + "-name")
              .attr("id", newFieldId + "-name");
            newField
              .find("#" + fieldId + "-disp")
              .attr("id", newFieldId + "-disp");
            newField
              .find("#" + fieldId + "-edit")
              .attr("id", newFieldId + "-edit");

            // Also rename any other inputs in the sequence item
            newField
              .find("input:radio, input:checkbox")
              .attr("name", newFieldId + "-is_main_contact");

            // If there the list item or the entire list if there is only one item left.
            if (
              eventTarget.closest("div.faux-results").find("div").length > 1
            ) {
              eventTarget.closest("div").remove();
            } else {
              eventTarget.closest("div.faux-results").remove();
            }

            field.after(newField);

            typeaheadSelectHandler(newFieldId, datum, false);
          });
        $(this)
          .closest(".object_ref_field")
          .on("click", ".seppuku", function (e) {
            e.preventDefault();
            // If there the list item or the entire list if there is only one item left.
            var eventTarget = $(e.target);
            if (
              eventTarget.closest("div.faux-results").find("div").length > 1
            ) {
              eventTarget.closest("div").remove();
            } else {
              eventTarget.closest("div.faux-results").remove();
            }
          });

        var typeaheadQueryTimeout = null;
        var typeaheadSource = {
          name: "search-results",
          displayKey: "label",
          templates: {
            suggestion: function (context) {
              if (context.id === null) {
                return $("<p></p>")
                  .append($("<b></b>").text(context.label))
                  .append(
                    $('<span class="text-muted"></span>').text(
                      " (" + createNew + ")"
                    )
                  );
              } else {
                var entry = $("<p></p>").text(context.label);
                if (context.object_type == 6 && context.sub_type == 1) {
                  // investment account
                  entry.append(
                    ' <span class="search-result-label small">entity</span>'
                  );
                } else if (context.object_type == 3 && context.sub_type == 1) {
                  // person
                  entry.append(
                    ' <span class="search-result-label small">' +
                      (context.company_name || "") +
                      "</span>"
                  );
                }
                return entry.html();
              }
            },
          },
          source: function (query, cb) {
            var executeSearch = function () {
              var excludeObjectIds =
                objectRefInput.data("exclude-object-ids") || "";
              if (excludeObjectIds != "") {
                typeaheadQueryOptions.x = excludeObjectIds;
              }
              var requestedObjectType = objectRefInput.data("object-type");

              // filter 'is_staff_or_person' is special in that it returns heterogeneous
              // object types, so don't restrict results by type.
              if (
                objectRefInput.data("object-filter") == "is_staff_or_person"
              ) {
                requestedObjectType = null;
              }
              $.get(
                "/search",
                $.extend({ q: query }, typeaheadQueryOptions),
                function (data) {
                  var results = data.results;

                  if (createNew) {
                    /* Add a "create new" option to the end if there are no exact matches */
                    var exactMatch = false;
                    if (!allowCreateNewOnExactMatch) {
                      for (var i = 0; i < results.length; i++) {
                        if (
                          results[i].label.toUpperCase() === query.toUpperCase()
                        ) {
                          exactMatch = true;
                          break;
                        }
                      }
                    }

                    if (!exactMatch) {
                      results.push({
                        id: null,
                        object_type: objectTypeId,
                        label: query,
                        url: null,
                      });
                    }
                  }

                  // Filter out any results on unexpected type
                  if (
                    typeof requestedObjectType != "undefined" &&
                    requestedObjectType
                  ) {
                    results = results.filter(function (result) {
                      return result.object_type == requestedObjectType;
                    });
                  }
                  cb(results);
                },
                "json"
              );
            };
            if (typeaheadQueryTimeout) {
              clearTimeout(typeaheadQueryTimeout);
              typeaheadQueryTimeout = null;
            }
            typeaheadQueryTimeout = setTimeout(executeSearch, 300);
          },
        };

        objectRefInput
          .typeahead(typeaheadOptions, typeaheadSource)
          .on("typeahead:selected", function (event, datum) {
            typeaheadSelectHandler(fieldId, datum);
          });

        objectRefInput.change(function () {
          if ($("#" + fieldId + "-name").val() != objectRefInput.val()) {
            $("#" + fieldId + "-type").val("");
            $("#" + fieldId + "-id").val("");
            $("#" + fieldId + "-name").val(objectRefInput.val());
            $("#" + fieldId + "-lazy_create").val("false");

            var isFreeText = objectRefInput.data("free-text");
            if (!isFreeText && objectRefInput.val() != "") {
              var formGroup = objectRefInput.closest(".form-group");
              formGroup.addClass("has-error");
            }
          }
        });

        var objectRefDisp = $("#" + fieldId + "-disp");
        objectRefDisp.find("a.close").click(function () {
          objectRefInput.typeahead("val", "");

          objectRefDisp.find("input").val("");
          objectRefDisp.addClass("hidden");
          $("#" + fieldId + "-type").val("");
          $("#" + fieldId + "-id").val("");
          $("#" + fieldId + "-name").val("");
          $("#" + fieldId + "-lazy_create").val("false");

          var objectRefEdit = $("#" + fieldId + "-edit");
          objectRefEdit.removeClass("hidden");
          objectRefInput.trigger("jsq:objectSelectionCleared");
        });
      });
    },

    initSelect2ObjectRefInputs: function (formNode) {
      // Initialize all select2_object_ref components in the form.
      formNode.find(".select2_object_ref_edit").each(function () {
        var objectRefInput = $(this);
        var fieldId = objectRefInput.attr("id");
        var objectTypeId = objectRefInput.data("object-type") || "";
        var targetListSelector = objectRefInput.data("target-list");

        // helps comply with the object_ref schema
        function applySelection(fieldId, datum) {
          $("#" + fieldId + "-type").val(objectTypeId || "");
          $("#" + fieldId + "-id").val((datum && datum.id) || "");
          $("#" + fieldId + "-name").val((datum && datum.text) || "");
          $("#" + fieldId + "-lazy_create").val("false");
        }

        objectRefInput.on("select2-selecting", function (e) {
          var data = $(targetListSelector).data("array") || [];
          var datum;

          for (var index = 0; index < data.length; index++) {
            const item = data[index];

            if (item.id === e.val) {
              datum = item;
              break;
            }
          }

          applySelection(fieldId, datum);
        });

        objectRefInput.on("select2-removed", function (e) {
          applySelection(fieldId, null);
        });
      });
    },

    initControlledVocabInputs: function (formNode) {
      // Initialize all controlled_vocab components in the form

      formNode.find("input:text.controlled-vocab").each(function () {
        var controlledVocabInput = $(this);
        var fieldId = controlledVocabInput.attr("id");
        var noun = controlledVocabInput.data("noun") || "label";

        var cvEngine = new Bloodhound({
          name: "controlled-vocab-" + fieldId,
          prefetch: {
            url: controlledVocabInput.data("prefetch-url"),
            ttl: 1000 * 60, // one minute
          },
          datumTokenizer: function (d) {
            return Bloodhound.tokenizers.whitespace(d.label);
          },
          queryTokenizer: Bloodhound.tokenizers.whitespace,
        });

        cvEngine.initialize();
        var cvEngineSource = cvEngine.ttAdapter();

        var dataSource = function (query, cb) {
          query = query.trim();
          cvEngineSource(query, function (results) {
            var exactMatch = false;
            for (var i = 0; i < results.length; i++) {
              if (results[i].label.toUpperCase() === query.toUpperCase()) {
                exactMatch = true;
                break;
              }
            }

            if (!exactMatch) {
              results.push({ id: null, label: query });
            }
            cb(results);
          });
        };

        controlledVocabInput
          .typeahead(
            {
              hint: false,
              autoselect: true,
            },
            {
              source: dataSource,
              displayKey: function (datum) {
                return datum.label;
              },
              templates: {
                suggestion: function (datum) {
                  if (datum.id === null) {
                    return $("<p></p>")
                      .append($("<b></b>").text(datum.label))
                      .append(" (new " + noun + ")");
                  } else {
                    return $("<p></p>").text(datum.label);
                  }
                },
                header: '<p class="tt-header">Choose a ' + noun + "</p>",
              },
            }
          )
          .on("typeahead:selected", function (event, datum) {
            controlledVocabInput.data("selected-text", datum.label);
          })
          .on("typeahead:closed", function (event) {
            if (
              controlledVocabInput.typeahead("val") &&
              controlledVocabInput.typeahead("val") !=
                controlledVocabInput.data("selected-text")
            ) {
              controlledVocabInput.val(
                controlledVocabInput.data("default") || ""
              );
            }
          })
          .blur(function (event) {
            if (
              controlledVocabInput.typeahead("val") &&
              controlledVocabInput.typeahead("val") !=
                controlledVocabInput.data("selected-text")
            ) {
              controlledVocabInput.val(
                controlledVocabInput.data("default") || ""
              );
            }
          });
      });
    },

    fireContentChange: function (formNode) {
      formNode.trigger("jsq:formContentChanged", []);
    },

    initDocumentUploader: function (formNode) {
      // Initialize the document name input field with the selected file's name
      formNode.on("jsq:fileSelect", function (e, files) {
        var title = $(this).find("#document_name");
        if (title) {
          title.attr("value", files[0].name);
        }
      });

      var formType = $("#upload-form").data("form-type");

      if (formType == "document") {
        $("#upload-form .upload-form-collection").addClass("hidden");
      } else if (formType == "collection") {
        $("#upload-form .upload-form-document").addClass("hidden");
      }

      // On document upload, submit the form and call the registered callback with the uploaded document ID
      formNode.on("jsq:documentUpload", function (e, f) {
        var emitter = $(this);

        // TODO: replace this with a marker for mandatory fields on forms.
        // Check if the document type selection has a value.  Block form submission if it does not since
        // this is a mandatory field and server-side error detection will wipe out the content of the
        // file-input.
        var mandatoryField = $(
          "#upload-form:not(.hidden) select[name=document_category_id]"
        );
        var mandatoryFieldLabel = "category";
        if (mandatoryField.length == 0) {
          mandatoryField = $(
            "#collection-upload-form:not(.hidden) select[name=document_collection_id]"
          );
          mandatoryFieldLabel = "collection";
        }
        if (!mandatoryField.val()) {
          if (mandatoryField.parent().find(".help-block").length == 0) {
            mandatoryField
              .parent()
              .append(
                '<span class="help-block">Please select a document ' +
                  mandatoryFieldLabel +
                  ".</span>"
              );
          }
          mandatoryField.closest(".form-group").addClass("has-error");
          mandatoryField.change(function (e) {
            mandatoryField.parent().find(".help-block").remove();
            mandatoryField.closest(".form-group").removeClass("has-error");
          });
          return;
        } else {
          if (mandatoryFieldLabel == "category") {
            $("select[name=document_collection_id]").val(null);
          }
        }

        // If the 'Share with' option is presented, its value is mandatory
        var shareWithInputNames = [
          "perms_all_positions",
          "perms_all_prospects",
        ];
        for (var i = 0; i < shareWithInputNames.length; i++) {
          var shareInputs = emitter.find(
            "input[name=" + shareWithInputNames[i] + "]"
          );
          if (shareInputs.length > 0) {
            if (
              emitter.find("input[name=" + shareWithInputNames[i] + "]:checked")
                .length == 0
            ) {
              var shareRadioGroup = $(shareInputs[0]).closest(".col-sm-9");
              var shareFormGroup = shareRadioGroup
                .closest(".form-group")
                .addClass("has-error");
              if (shareFormGroup.find(".help-block").length == 0) {
                shareRadioGroup.append(
                  '<div class="help-block">Please select a sharing option.</div>'
                );
              }
              shareInputs.change(function (e) {
                shareRadioGroup.closest(".form-group").removeClass("has-error");
                shareRadioGroup.find(".help-block").remove();
              });
              return;
            }
            break;
          }
        }

        // need to handle this error case for document sharing sub-selections, and should not be able to save in this state
        if (formNode.find("div.document-share.has-error").length) {
          return;
        }

        // Switch from the upload-form view to the upload-status view.
        emitter.find("#upload-form").addClass("hidden");
        emitter.find("#collection-upload-form").addClass("hidden");
        emitter.find("#upload-status").removeClass("hidden");
        emitter.find("#corrupted-error-div").addClass("hidden");

        emitter.find(".alert-danger:has(p.error-msg)").addClass("hidden");

        // If the form is inside of a modal, then switch the buttons in the footer to those relevant
        // to the upload-status view.
        var modalNode = formNode.closest(".modal");
        if (modalNode.length > 0) {
          // Hide the 'x' button in the modal header since this cant be cancelled after upload has started.
          modalNode
            .find('.modal-header button[data-dismiss="modal"]')
            .addClass("hidden");

          // Hide the 'upload' button and relabel the 'cancel' button to 'continue' and disable it until success.
          modalNode
            .find('button[data-save-event="jsq:documentUpload"]')
            .addClass("hidden");
          var cancelButton = modalNode.find(
            '.modal-footer button[data-dismiss="modal"]'
          );
          var cancelButtonContainer = cancelButton.parent();
          if (
            cancelButtonContainer &&
            cancelButtonContainer.attr("id") &&
            cancelButtonContainer.attr("id").indexOf("DocumentsPillar") !== -1
          ) {
            // Pillar events cannot be directly disabled from raw JS, hide instead
            cancelButton.addClass("hidden");
          } else {
            cancelButton
              .addClass("btn-primary")
              .text("Continue")
              .addClass("disabled");
          }
        }

        var uploadObjectType = emitter.find("input[name=object_type]").val();
        var uploadObjectId = emitter.find("input[name=object_id]").val();

        var progressBar = emitter.find("#upload-status .progress-bar");

        // Helper function to switch from the upload-status view to the upload-form view on error.
        var switchToUploadForm = function () {
          emitter.find("#upload-form").removeClass("hidden");
          emitter.find("#upload-status").addClass("hidden");
          progressBar.width("0%").text("0%");

          if (modalNode.length > 0) {
            // Hide the 'x' button in the modal header since this cant be cancelled after upload has started.
            modalNode
              .find('.modal-header button[data-dismiss="modal"]')
              .removeClass("hidden");

            // Hide the 'upload' button and relabel the 'cancel' button to 'continue' and disable it until success.
            modalNode
              .find('button[data-save-event="jsq:documentUpload"]')
              .removeClass("hidden");
            var cancelButton = modalNode.find(
              '.modal-footer button[data-dismiss="modal"]'
            );
            var cancelButtonContainer = cancelButton.parent();
            if (
              cancelButtonContainer &&
              cancelButtonContainer.attr("id") &&
              cancelButtonContainer.attr("id").indexOf("DocumentsPillar") !== -1
            ) {
              cancelButton.removeClass("hidden");
            } else {
              cancelButton
                .removeClass("btn-primary")
                .text("Cancel")
                .removeClass("disabled");
            }
            require(["components/dom_setup"], function (domSetup) {
              domSetup.init(modalNode);
            });
          }
        };

        var formData = formComponent.serialize(formNode);
        formData.append(
          "csrf_token",
          $("meta[name=csrf_token]").attr("content")
        );

        // Persist the bulk sharing context through error validation
        var forBulkShareElement = formNode.find("#for_bulk_share");
        var forBulkShare =
          forBulkShareElement.length > 0 &&
          forBulkShareElement.val() === "True";

        $.ajax({
          url:
            "/document/add/" +
            uploadObjectType +
            "/" +
            uploadObjectId +
            (forBulkShare ? "?for_bulk_share" : ""),
          type: "POST",
          data: formData,
          processData: false,
          contentType: false,
          dataType: "json",
          success: function (result) {
            if (result.status != "ok") {
              var formParent = formNode.parent();
              formParent.html(result.body);
              formComponent.init(formParent.find("form"));
              switchToUploadForm();
              if (result.status === "error") {
                var errorNode = formNode.find(".alert-danger p.error-msg");
                if (errorNode.length > 0) {
                    formNode.find(".alert-danger:has(p.error-msg)").removeClass("hidden");
                    errorNode.text(result.error_message);
                } else {
                  var errorMarkup =
                    '<div class="alert alert-danger"><p class="error-msg">' +
                    result.error_message +
                    "</p></div>";
                  formNode
                    .find("#upload-form")
                    .first(".form-group")
                    .before(errorMarkup);
                }
              }

              if(result.status === "corruption_error"){
                  var corruptedFileDiv = $('#corrupted-error-div');
                  corruptedFileDiv.removeClass('hidden');
                  corruptedFileDiv.find('.corrupted-error-msg').text("This file is corrupted");
                  corruptedFileDiv.find('.corrupted-error-file-message').text("The file appears to be corrupted. Try uploading it again or use a different file format.");
              }

              return;
            }
            formComponent.resetSaveWarning(formNode);
            formNode.trigger("jsq:documentUploadComplete", [
              result.location,
              result.document_id,
            ]);
            modalNode.modal("hide");
            return true;
          },
          error: function (jqxhr, textStatus, errorThrown) {
            switchToUploadForm();
            var errorMessage = jqxhr.responseText;
            if (jqxhr.status == 413) {
              errorMessage =
                "The file you selected exceeds our file size limit of 300MB.  Please try a smaller file.";
            } else if (jqxhr.state() === "rejected") {
              errorMessage = "Document could not upload because the file is invalid.";
            } else if (jqxhr.status == 500 || !errorMessage) {
              errorMessage =
                "There was an unexpected error uploading this document.";
            }
            var errorNode = formNode.find(".alert-danger p.error-msg");
            if (errorNode.length > 0) {
              errorNode.text(errorMessage);
            } else {
              var errorMarkup =
                '<div class="alert alert-danger"><p class="error-msg">' +
                errorMessage +
                "</p></div>";
              formNode
                .find("#upload-form")
                .first(".form-group")
                .before(errorMarkup);
            }
          },
          xhr: function () {
            var xhr = $.ajaxSettings.xhr();
            xhr.upload.onprogress = function (e) {
              var pc = Math.round((e.loaded / e.total) * 100);
              progressBar.width(pc + "%");
              $("#upload-status-message").text(pc + "%");
              if (pc == 100) {
                $("#upload-status-message").text("Processing...");
              }
            };
            return xhr;
          },
        });
      });
    },

    initializeSingleSelect2: function (select2Node) {
      var targetListSelector = select2Node.data("target-list");
      var targetListData = $(targetListSelector).data("array");

      var params = {
        allowClear: true,
        placeholder: select2Node.data("placeholder"),
      };

      if (select2Node.data("is-country-list")) {
        // We want countries to match only if search term is prefix, not if it's a substring
        params.matcher = function (term, text) {
          return text.toUpperCase().indexOf(term.toUpperCase()) == 0;
        };

        // We want to sort the displayed results by population
        params.sortResults = function (results, container, query) {
          if (query.term) {
            return results.sort(function (a, b) {
              if (a.population > b.population) {
                return -1;
              } else if (a.population < b.population) {
                return 1;
              } else {
                return 0;
              }
            });
          }
          return results;
        };
      }

      if (select2Node.data("is-email-list")) {
        params.separator = ";";
        // This create a new tag when the user presses ';' or ','
        // SPACE is not in tokenSeparators because autocompletion for staff users
        // show the staff user's full name, which contains spaces.
        params.tokenSeparators = [";", ","];

        // select2 expects `params.tags` instead of `params.data`
        params.tags = targetListData;
      } else {
        params.data = targetListData;
      }

      if (select2Node.data("lazy-create")) {
        params["query"] = function (options) {
          if (!options.term || options.term.trim() === "") {
            options.callback({ results: params["data"] });
            return;
          }
          var data = { results: [] };
          var exactMatch = false;
          $.each(targetListData, function () {
            if (
              options.term.length == 0 ||
              this.text.toUpperCase().indexOf(options.term.toUpperCase()) >= 0
            ) {
              data.results.push({ id: this.id, text: this.text });
              exactMatch |=
                this.text.toUpperCase() == options.term.toUpperCase();
            }
          });
          var lazyCreateLabel = select2Node.data("lazy-create-label");
          if (!exactMatch && typeof lazyCreateLabel == "undefined") {
            data.results.push({ id: options.term, text: options.term });
          }
          if (lazyCreateLabel) {
            data.results.push({ id: -1, text: lazyCreateLabel });
          }
          options.callback(data);
        };
        params["initSelection"] = function (element, callback) {
          var id = element.val();
          for (var i = 0; i < params.data.length; i++) {
            if (params.data[i].id == id) {
              callback(params.data[i]);
              break;
            }
          }
        };
      }
      if (select2Node.hasClass("entity-collection")) {
        // Remove the "No matches found" in empty results and provide a class to remove the magnifying glass
        params["formatNoMatches"] = function () {
          return "";
        };
        params["dropdownCssClass"] = "entity-collection-dropdown";
      }
      select2Node.select2(params);
      if (select2Node.data("disabled")) {
        select2Node.prop("disabled", true);
      }
      if (select2Node.hasClass("entity-collection")) {
        // Restore collection to be created on-the-fly when re-rendering the form after an error
        const selectValue = select2Node.val();
        const displaySpan = select2Node
          .siblings(".select2-container")
          .find(".select2-chosen");
        const displaySpanText = displaySpan.text();
        if (selectValue && (!displaySpanText || !displaySpanText.trim())) {
          displaySpan.text(selectValue);
        }
      }
    },

    initSelect2: function (formNode) {
      // Only find <input> or <select> elements; select2 converts these to <div class="select2">,
      // so we do not want to call `initializeSingleSelect2()` on those.
      formNode.find("input.select2, select.select2").each(function () {
        formComponent.initializeSingleSelect2($(this));
      });
    },

    initDocumentSharingAdd: function (formNode) {
      formNode.find(".document-share-add-another").click(function (e) {
        e.preventDefault();
        var dest = $($(this).data("dest"));
        dest.append($(this).data("template"));
        formComponent.initializeSingleSelect2(dest.find(".select2:last-child"));
      });
    },

    initListSortDnD: function (formNode) {
      var sortableList = formNode.find("ul.sortable-list, ol.sortable-list");
      if (sortableList.length == 0) {
        return;
      }

      sortableList
        .on("dragstart", function (e) {
          var target = $(e.target);
          if (e.target.tagName.toLowerCase() != "li") {
            target = target.closest("li");
          }
          target.addClass("dragging");
          e.originalEvent.dataTransfer.effectAllowed = "move";
          target.closest("ul").data("dragging-id", target.attr("id"));
        })
        .on("dragenter", function (e) {
          e.originalEvent.dataTransfer.dropEffect = "move";
          var draggedId = $(e.target).closest("ul").data("dragging-id");
          if (draggedId) {
            // move the item here
            var source = $("#" + draggedId);
            var target = $(e.target).closest("li");
            if (target.index() < source.index()) {
              $(e.target).closest("li").addClass("drag-over-drop-top");
            } else if (target.index() > source.index()) {
              $(e.target).closest("li").addClass("drag-over-drop-bottom");
            }
          }
        })
        .on("dragover", function (e) {
          e.preventDefault(); // Necessary. Allows us to drop.
          e.originalEvent.dataTransfer.dropEffect = "move";
          var draggedId = $(e.target).closest("ul").data("dragging-id");
          if (draggedId) {
            // move the item here
            var source = $("#" + draggedId);
            var target = $(e.target).closest("li");
            if (target.index() < source.index()) {
              $(e.target).closest("li").addClass("drag-over-drop-top");
            } else if (target.index() > source.index()) {
              $(e.target).closest("li").addClass("drag-over-drop-bottom");
            }
          }
          return false;
        })
        .on("dragleave", function (e) {
          $(e.target)
            .closest("li")
            .removeClass("drag-over")
            .removeClass("drag-over-drop-top")
            .removeClass("drag-over-drop-bottom");
        })
        .on("drop", function (e) {
          e.preventDefault();
          var draggedId = $(e.target).closest("ul").data("dragging-id");
          if (draggedId) {
            // move the item here
            var source = $("#" + draggedId);
            var target = $(e.target).closest("li");
            if (target.index() > source.index()) {
              target.after(source);
            } else {
              target.before(source);
            }
            $(e.target)
              .closest("li")
              .removeClass("drag-over")
              .removeClass("drag-over-drop-top")
              .removeClass("drag-over-drop-bottom");

            // Compute new sort_order for each item
            target
              .siblings()
              .andSelf()
              .each(function (idx, listItem) {
                $(this).find("input[name=sort_order]").val(idx);
              });

            sortableList.trigger("jsq:listResorted", []);
          }
        })
        .on("dragend", function (e) {
          var target = $(e.target);
          if (e.target.tagName.toLowerCase() != "li") {
            target = target.closest("li");
          }
          target.removeClass("dragging");
        });
    },

    initExclusiveCheckbox: function (formNode) {
      formNode
        .find("input[type=checkbox].exclusive-checkbox")
        .click(function () {
          var isChecked = $(this).prop("checked");
          var checkboxName = $(this).attr("name");
          $("input[type=checkbox].exclusive-checkbox").prop("checked", false);
          $(this).prop("checked", isChecked);
        });
    },

    initAddressField: function (formNode) {
      // Street2 and Street3 behavior for address fields
      formNode
        .find(".row.addr-street, .form-group.addr-street")
        .keydown(function (e) {
          if (
            e.which != 9 && // tab
            e.which != 27 && // escape
            !e.ctrlKey &&
            !e.altKey &&
            !e.shiftKey &&
            !e.metaKey
          ) {
            $(this).next(".addr-street").removeClass("hidden");
          }
        });
    },

    _initSaveWarning: function (formNode) {
      // Activate save-warning bit on any change to the form.

      var formId = formNode.attr("id");
      if (!formId || formNode.hasClass("no-warn")) return;

      // formComponent.changedFieldNames[formId] usually gets cleared
      // in formComponent._handleBeforeUnload(), but
      // formComponent.init() will be called again on a new form instance with
      // the *same* formId if the user saves a form and then re-opens
      // the form for a subsequent edit without first navigating away.
      // To handle this case, make sure to call formComponent.resetSaveWarningForFormId(formId)
      // to clear the old formComponent.changedFieldNames[formId].
      // NOTE: When a form is validated, the server sends back
      // a new version of the form's html along with `.has-error` or `.error-msg` elements;
      // in this case, we do not want call formComponent.resetSaveWarningForFormId(formId)
      // because the user still hasn't finished correcting the form.
      var hasErrors = formNode.find(".has-error, .error-msg").length > 0;
      if (!hasErrors) {
        formComponent.resetSaveWarningForFormId(formId);
      }

      formNode.change(function (e) {
        var input = $(e.target);
        if (input.hasClass("no-warn")) {
          return;
        }
        if (
          !Object.prototype.hasOwnProperty.call(formComponent.changedFieldNames, formId) ||
          formComponent.changedFieldNames[formId].length == 0
        ) {
          window.onbeforeunload = formComponent._handleBeforeUnload;
        }
        if (!Object.prototype.hasOwnProperty.call(formComponent.changedFieldNames, formId)) {
          formComponent.changedFieldNames[formId] = [];
        }
        var label = formNode.find("label[for='" + input.attr("id") + "']");
        if (label.length == 0) {
          var seq = input.closest(".deform-seq");
          if (seq) {
            label = formNode.find("label[for='" + seq.attr("id") + "']");
          }
        }
        if (label.length > 0) {
          label = label.text().trim();
          if (formComponent.changedFieldNames[formId].indexOf(label) == -1) {
            formComponent.changedFieldNames[formId].push(label);
          }
        }
      });
    },

    forceSaveWarning: function (formNode) {
      formComponent.changedFieldNames[formNode.attr("id")] = [];
      window.onbeforeunload = formComponent._handleBeforeUnload;
    },

    // Most of the time it is not necessary to call resetSaveWarning()
    // because _handleBeforeUnload() takes care of this automatically.
    // However, forms that are reused across multiple submissions will
    // need to call this function after each submission (ie: the '#add-note-form' form in updates.js).
    resetSaveWarning: function (formNode) {
      formComponent.resetSaveWarningForFormId(formNode.attr("id"));
    },
    resetSaveWarningForFormId: function (formId) {
      if (formId in formComponent.changedFieldNames) {
        delete formComponent.changedFieldNames[formId];
      }
    },
    clearAllSaveWarnings: function () {
      formComponent.changedFieldNames = {};
      window.onbeforeunload = null;
    },
    _resetSaveWarningsForStaleForms: function () {
      $.each(formComponent.changedFieldNames, function (formId) {
        // Reset if the form has been removed (such as clicking Cancel).
        var formEl = $("#" + formId + ":visible")[0];
        if (!formEl) formComponent.resetSaveWarningForFormId(formId);
      });

      if ($.isEmptyObject(formComponent.changedFieldNames)) {
        window.onbeforeunload = null;
      }
    },
    _getUnsavedFieldNames: function () {
      var fieldNames = [];
      $.each(formComponent.changedFieldNames, function (formId, names) {
        fieldNames = fieldNames.concat(names);
      });
      return fieldNames;
    },
    _handleBeforeUnload: function () {
      var fieldNames = [];

      formComponent._resetSaveWarningsForStaleForms();

      // If _resetSaveWarningsForStaleForms() voided window.onbeforeunload, just do nothing.
      if (!window.onbeforeunload) return;

      var fieldNames = formComponent._getUnsavedFieldNames();

      if (fieldNames.length > 0) {
        return "You have unsaved changes on: " + fieldNames.join(", ");
      } else {
        return "You have unsaved changes.";
      }
    },

    focusFirstInput: function (formNode) {
      formNode
        .find(
          "input:text:not(:disabled):not(.datepicker-field):visible,select:not(:disabled):visible,input:radio:not(:disabled):visible,input:checkbox:not(:disabled),textarea:not(:disabled):visible,input:file:not(:disabled)"
        )
        .first()
        .focus();
    },

    scrollToFirstError: function (formNode) {
      var viewportTop = $(window).scrollTop(),
        firstError = formNode.find(".has-error").first(),
        scrollableNode;
      if (firstError.length == 0) {
        firstError = formNode.find(".text-danger").first();
      }
      scrollableNode = firstError.length > 0 ? firstError : formNode;
      if (scrollableNode.offset().top < viewportTop) {
        $("html,body").animate({ scrollTop: scrollableNode.offset().top - 90 });
      }
    },

    // Deform sequence item append click handler
    appendSequenceItem: function (addNode) {
      var $oid_node = addNode.closest(".deform-seq");
      var $proto_node = $oid_node.find(".deform-proto").first();
      var $before_node = $oid_node.find(".deform-insert-before").last();
      var min_len = parseInt($before_node.attr("min_len") || "0", 10);
      var max_len = parseInt($before_node.attr("max_len") || "9999", 10);
      var now_len = parseInt($before_node.attr("now_len") || "0", 10);
      var orderable = parseInt($before_node.attr("orderable") || "0", 10);
      if (now_len < max_len) {
        var $new_node = formComponent._addSequenceItem(
          $proto_node,
          $before_node
        );
        formComponent.initSequenceItem($new_node);
      }
    },

    // Deform sequence item initializer
    initSequenceItem: function (sequenceItem) {
      formComponent.initObjectRefInputs(sequenceItem);
      formComponent.initControlledVocabInputs(sequenceItem);
      formComponent.initSelect2(sequenceItem);
      formComponent.initSelect2ObjectRefInputs(sequenceItem);
      formComponent.initDatePicker(sequenceItem);
      formComponent.initExclusiveCheckbox(sequenceItem);
      formComponent.initAddressField(sequenceItem);
      formComponent.focusFirstInput(sequenceItem);

      // If this is the first primary-email-address radio, mark it checked
      if (
        sequenceItem.find('input:radio[name="is_primary"]') &&
        sequenceItem.closest(".deform-seq").find(".deform-seq-item").length == 1
      ) {
        sequenceItem
          .find('input:radio[name="is_primary"]')
          .prop("checked", true);
      }

      require(["components/utils"], function (utils) {
        utils.init(sequenceItem);
      });
      require(["components/dom_setup"], function (domSetup) {
        domSetup.init(sequenceItem);
      });
      var deformSeqContainer = sequenceItem.closest(".deform-seq-container");
      deformSeqContainer.trigger("jsq:sequenceItemCreated", [sequenceItem]);
    },

    // Deform sequence item delete handler
    removeSequenceItem: function (clicked) {
      var $item_node = $(clicked).closest(".deform-seq-item");
      var deformSeqContainer = $item_node.closest(".deform-seq-container");
      var $oid_node = $item_node.closest(".deform-seq");
      var $before_node = $oid_node.find(".deform-insert-before").last();
      var min_len = parseInt($before_node.attr("min_len") || "0", 10);
      var max_len = parseInt($before_node.attr("max_len") || "9999", 10);
      var now_len = parseInt($before_node.attr("now_len") || "0", 10);
      var orderable = parseInt($before_node.attr("orderable") || "0", 10);
      if (now_len > min_len) {
        $before_node.attr("now_len", now_len - 1);
        $item_node.remove();
      }
      deformSeqContainer.trigger("jsq:sequenceItemRemoved", [$before_node]);
    },

    updateRecallableOption: function(positionInputNode) {
      // A helper function to handle the show and hide of the recallable option on the form
      function showHideRecallableFieldHandler(positionInputNode, isShow, isCapitalCall) {
        // get all the recallable option components within the target form
        const $recallableOptionComponents = positionInputNode.closest('form').find('[id="recallable-option"]');
        // check if the recallable options are currently showing or not
        const isShowing = !$recallableOptionComponents.hasClass("hidden");
        // This is for the edge where all amount rows are removed when the position is changed
        const hasRecallableComponent = $recallableOptionComponents.length > 0;

        // proceed to update the DOM elements if current state is different from the to be state or there is no amount rows currently
        if (isShowing !== isShow || !hasRecallableComponent){
          // get the seq components and extract the data
          const $oid_node = hasRecallableComponent ? $recallableOptionComponents.closest(".deform-seq") : positionInputNode.closest("form").find(".deform-seq").first();
          const $proto_node = $oid_node.find(".deform-proto").first();
          const code = $proto_node.attr("prototype");
          const html = decodeURIComponent(code);
          const htmlArr = html.split('id="recallable-option"');

          // div with id="recallable-option" is not returned for negative transaction types
          // return without updating the DOM if that's the case
          if (htmlArr.length < 2) {
              return false;
          }

          // remove the hidden class from all elements and prototype if want to show the option
          // otherwise add the hidden class to elements and protoype
          if (isShow) {
            $recallableOptionComponents.removeClass("hidden");
            htmlArr[1] = htmlArr[1].replace("hidden", "");
          } else {
            $recallableOptionComponents.addClass("hidden");
            // replace phrase is different between capital activity page and capital call page
            const replacePhrase = isCapitalCall ? "col-sm-2 amount-recalled-options col-override-gutter" : "form-group";
            htmlArr[1] = htmlArr[1].replace(replacePhrase, replacePhrase + " hidden");
          }

          const updatedHtml = htmlArr.join('id="recallable-option"');
          const encode = encodeURIComponent(updatedHtml);
          // update the protoype
          $proto_node.attr("prototype", encode);
          return true;
        }
        return false;
      }

      // get position id
      const positionId = positionInputNode.context.value
      const urlArr = window.location.href.split("/");
      // check if the current page is capital call page
      const cc_index = urlArr.indexOf("capital_call_batch");
      
      // make ajax call to check if the position has recallable if a position is selected
      if (positionId) {
        // construct the post request data
        const reqData =  {
          csrf_token: $("meta[name=csrf_token]").attr("content"),
        }
        // if in capital call page, attach the batch id to reqData
        if (cc_index !== - 1) {
          reqData["batch_id"] = parseInt(urlArr[cc_index + 1]);
        }

        // fetch if the position has recallable
        $.ajax({
          url:
            "/position/" + positionId + "/has_remaining_recallable",
          type: "POST",
          dataType: "json",
          data: reqData,
          success: function (result) {
            const showRecallable = result["has_remaining_recallable"];
            showHideRecallableFieldHandler(positionInputNode, showRecallable, cc_index !== -1)
          },
          error: function (jqxhr, textStatus, errorThrown) {
            const errorMessage = "There was an unexpected error when retrieving the recallable amount of the position"
            const errorMarkup =
                  '<br><div class="alert alert-danger" style="margin-bottom: 0"><p class="error-msg">' +
                  errorMessage +
                  "</p></div>";
            $(positionInputNode.context.parentElement).after(errorMarkup);
          },
        });
      } else {
        // if no position is selected, hide recallable option field
        showHideRecallableFieldHandler(positionInputNode, false, cc_index !== -1)
      }
    },

    _addSequenceItem: function (protonode, before) {
      // - Clone the prototype node and add it before the "before" node.
      //   Also ensure any callbacks are run for the widget.

      // In order to avoid breaking accessibility:
      //
      // - Find each tag within the prototype node with an id
      //   that has the string ``deformField(\d+)`` within it, and modify
      //   its id to have a random component.
      // - For each label referencing an change id, change the label's
      //   for attribute to the new id.

      var fieldmatch = /deformField(\d+)/g;
      var namematch = /(.+)?-[#]{3}/;
      var code = protonode.attr("prototype");
      var html = decodeURIComponent(code);
      var $htmlnode = $(html);
      var $idnodes = $htmlnode.find("[id]");
      var $namednodes = $htmlnode.find("[name]");
      var $hideTargetNodes = $htmlnode.find("[data-hide-target]");
      var $revealTargetNodes = $htmlnode.find("[data-reveal-target]");
      var genid = formComponent.randomString(6);
      var idmap = {};

      // replace ids containing ``deformField`` and associated label for=
      // items which point at them

      $idnodes.each(function (idx, node) {
        var $node = $(node);
        var oldid = $node.attr("id");
        var newid = oldid.replace(fieldmatch, "deformField$1-" + genid);
        $node.attr("id", newid);
        idmap[oldid] = newid;
        var labelselector = "label[for=" + oldid + "]";
        var $fornodes = $htmlnode.find(labelselector);
        $fornodes.attr("for", newid);
      });

      // replace names a containing ```deformField`` like we do for ids

      $namednodes.each(function (idx, node) {
        var $node = $(node);
        var oldname = $node.attr("name");
        var newname = oldname.replace(fieldmatch, "deformField$1-" + genid);
        $node.attr("name", newname);
      });

      // Replace values for the 'hide-target' data attribute on 'reveal-hidden' components
      $hideTargetNodes.each(function (idx, node) {
        var $node = $(node);
        var olddata = $node.data("hide-target");
        var newdata = olddata.replace(fieldmatch, "deformField$1-" + genid);
        $node.data("hide-target", newdata);
      });

      // Replace values for the 'reveal-target' data attribute on 'reveal-hidden' components
      $revealTargetNodes.each(function (idx, node) {
        var $node = $(node);
        var olddata = $node.data("reveal-target");
        var newdata = olddata.replace(fieldmatch, "deformField$1-" + genid);
        $node.data("reveal-target", newdata);
      });

      $htmlnode.insertBefore(before);

      var old_len = parseInt(before.attr("now_len") || "0", 10);
      before.attr("now_len", old_len + 1);
      return $htmlnode;
    },

    randomString: function (length) {
      var chr = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
      chr = chr.split("");

      if (!length) {
        length = Math.floor(Math.random() * chr.length);
      }

      var str = "";
      for (var i = 0; i < length; i++) {
        str += chr[Math.floor(Math.random() * chr.length)];
      }
      return str;
    },
  };

  // Just listen for clicks on 'a[data-role="cancel-form"]' anywhere in the dom.
  // Usually the 'Cancel' link is contained within the form element,
  // but sometimes it is adjacent to the form element (in which case we expect the link to have 'data-form-id').
  $("body")
    .off("click.JSQCancelFormLink")
    .on(
      "click.JSQCancelFormLink",
      'a[data-role="cancel-form"]',
      function (event) {
        var link = $(event.target);
        var formId = link.attr("data-form-id");
        var formNode = formId ? $("#" + formId) : link.closest("form");
        formComponent.resetSaveWarning(formNode);
      }
    );

  return formComponent;
});

